import { useStatusCommentPromptStore } from '@/store/status-comment-prompt.store'

import { StatusCommentDialog } from './StatusCommentDialog'

/**
 * The single mount point for the status comment prompt (SD-145). Rendered
 * once near the app root; every surface asks through
 * useStatusCommentPromptStore.requestComment and awaits the result.
 */
export function StatusCommentPromptHost() {
  const pending = useStatusCommentPromptStore(state => state.pending)
  const settle = useStatusCommentPromptStore(state => state.settle)

  if (!pending) return null

  return (
    <StatusCommentDialog
      // A fresh dialog (and empty textarea) per prompt.
      key={pending.id}
      open
      statusName={pending.statusName}
      statusColor={pending.statusColor}
      taskCount={pending.taskCount}
      onSubmit={comment => settle(comment)}
      onCancel={() => settle(null)}
    />
  )
}
